import React from 'react';
import styled from 'styled-components';

import type { IResourceDocumentItem } from '@/api/types';

import { ResourceDocument } from '@/assets/icons';
import { otherColors } from '@/styles/colors';
import { html } from '@/helpers';
import { Attachment } from '@/components/common';

interface IProps {
  resource: IResourceDocumentItem;
}

const DocumentPreview = ({ resource }: IProps): React.ReactElement => {
  return (
    <Container>
      <Title>
        <TitleIcon src={ResourceDocument} />
        <h1>{resource.name}</h1>
      </Title>
      <TextContainer>{html(resource.description || resource.shortDescription)}</TextContainer>
      <Attachment fileName={resource.name} actions={{ preview: resource.path }} />
    </Container>
  );
};

export { DocumentPreview };

const Container = styled.div`
  margin-top: 24px;
  overflow: auto;

  h1 {
    font-size: 30px;
    font-weight: 300;
    color: ${otherColors.lxc.darkBlue};
    margin: 0;
  }
`;

const TextContainer = styled.div`
  font-size: 14px;
  margin-bottom: 32px;
  max-width: 680px;
`;

const TitleIcon = styled.img`
  width: 26px;
  height: 26px;
  margin-right: 12px;
  margin-top: 5px;
`;

const Title = styled.div`
  display: flex;
  margin-bottom: 26px;
`;
